import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import api from '../api';
export default function NotificationBell() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let active = true, pending = false;
    const refresh = async () => {
      if (pending || document.hidden) return;
      pending = true;
      try { const { data } = await api.get('/api/notifications/count'); if (active) setCount(Math.max(0, Number(data.unread) || 0)); }
      catch { /* Keep header usable when notifications are unavailable. */ }
      finally { pending = false; }
    };
    refresh(); const timer = setInterval(refresh, 15000);
    window.addEventListener('esf-notifications-changed', refresh); window.addEventListener('focus', refresh);
    return () => { active = false; clearInterval(timer); window.removeEventListener('esf-notifications-changed', refresh); window.removeEventListener('focus', refresh); };
  }, []);
  return <Link to="/notifications" className="site-notification-bell" aria-label={count ? `اعلان‌ها، ${count} خوانده‌نشده` : 'اعلان‌ها'}><Bell size={19} />{count > 0 && <b className="site-unread">{count > 99 ? '۹۹+' : count.toLocaleString('fa-IR')}</b>}</Link>;
}
